import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import TripForm from "./tripComponents/TripForm";

import {
  useGetTripDetailQuery,
  useUpdateTripMutation,
} from "store/services/tripApi";

import { useAppMeta } from "hooks";

const TripEditScreen = () => {
  const { id } = useParams();

  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Trips", path: "/app/crm/trip/list" },
    { title: "Edit Trip" },
  ];

  // RTK Query
  const {
    data: tripDetail,
    isLoading: loadingTrip,
    error,
  } = useGetTripDetailQuery(id);

  const [updateTrip, { isLoading: updatingTrip }] = useUpdateTripMutation();

  // methods
  // In TripEditScreen.js
  const handleUpdateTrip = async (data) => {
    try {
      await updateTrip({ id, ...data }).unwrap();
      toast.success("Trip successfully updated!");
      navigate(`/app/crm/trip/${id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? err?.message ?? "Couldn't update Trip!");
    }
  };

  useAppMeta("Edit Trip");

  return (
    <BreadcrumbLayout
      breadcrumbs={breadcrumbs}
      isBusy={loadingTrip || updatingTrip}
    >
      <BreadcrumbLayout.Error error={error} />

      <BreadcrumbLayout.Paper>
        <TripForm
          isBusy={loadingTrip || updatingTrip}
          tripDetail={tripDetail}
          onSubmit={handleUpdateTrip}
        />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default TripEditScreen;